// extracted by mini-css-extract-plugin
export default {"searchInput":"styles_searchInput__3nZa-"};